module.exports = __webpack_public_path__ + "img/logo_fuseaccess.038b5eab.png";